<template>
  <paginator :total-count="totalCount" :page-size="pageSize" :active-page="currentPage"
             @pageActivated="pageActivated"/>
</template>

<script>
import Paginator from '../paginator/Paginator'
import { mapState } from 'vuex'
import { SET_INVOICE_SPECIFICATIONS_CURRENT_PAGE_NUMBER } from '../../store/modules/invoice-specifications/mutation-types'

export default {
  name: 'InvoiceListPaginator',
  components: {
    Paginator
  },
  props: {
    pageSize: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState({
      totalCount:
        state => state.invoiceSpecifications.totalNoInvoiceSpecificationsForCurrentFilter,
      currentPage: state => state.invoiceSpecifications.invoiceSpecificationsCurrentPageNumber
    })
  },
  methods: {
    pageActivated: function (pageNumber) {
      this.$store.commit(`invoiceSpecifications/${SET_INVOICE_SPECIFICATIONS_CURRENT_PAGE_NUMBER}`, {number: pageNumber})
      this.$emit('paginationChanged')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoiceSpecifications/InvoiceSpecificationsListPaginator.vue